@let apartment = apartment$ | async;
@let relevantApartmentsInputValue = relevantApartmentsInput();
@if (apartment && relevantApartmentsInputValue) {
  <homey-apartment-detail-page-content
    [apartment]="apartment"
    [householdSize]="1"
    [relevantApartmentsInput]="relevantApartmentsInputValue"
    [showH2]="true"
    [showEligibilityCarouselCta]="showCarouselEligibilityCta()"
  >
    <ng-container apartmentUnits>
      @if (apartment.type === 'regular') {
        @let eligibleResult = apartment | relevantAdvertisements: relevantApartmentsInputValue;
        @if (eligibleResult.status === 'eligible') {
          <homey-apartment-detail-info-item

            icon="pi-warehouse"
            title="Eligible units">
              <homey-regular-eligible-units [eligibleUnits]="eligibleResult.advertisements" />
          </homey-apartment-detail-info-item>
        }
      }
      @else {
        @let eligibleResult = apartment | relevantAdvertisements: relevantApartmentsInputValue;
        @if (eligibleResult.status === 'eligible') {
          <homey-apartment-detail-info-item
            icon="pi-warehouse"
            title="Eligible units">
            <homey-senior-eligible-units [eligibleUnits]="eligibleResult.advertisements" />
          </homey-apartment-detail-info-item>
        }
    }
    </ng-container>
  </homey-apartment-detail-page-content>
  @if (signupToApplyRoute()) {
    <a pButton class="w-full block mt-4" [routerLink]="signupToApplyRoute()">Sign up to apply</a>
  }
}
